export const noopStore = {
    getItem: async () => null,
    setItem: async () => { },
};
